import * as React from 'react'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { ServiceList } from '../ServiceList'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  SimpleAccordion,
  SimpleAccordionSummary,
  SimpleAccordionDetails,
} from '@sales-center/components'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'
import { IServiceFrequency } from '@user/store/serviceFrequency/typings'
import { useData, useHandlers } from './hooks'
import { Title } from './styled'
import { FieldArrayRenderProps } from 'formik'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import useTheme from '@mui/material/styles/useTheme'

type Props = {
  onEditClick?: (service: ILeadOppProduct) => void
  arrayHelpers: FieldArrayRenderProps
  defaultExpanded?: boolean
  disabled: boolean
  disableGrayBg?: boolean
  deleteServiceWarningMessage?: string
  entityType: ENTITY_TYPES
  loading: boolean
  localMode: boolean
  location: LocationDTO
  minimumServicesCount?: number
  readOnly?: boolean
  serviceFrequencies: IServiceFrequency[]
  serviceLocation: LocationDTO
  totalServicesCount?: number
}

export function ServiceLocationSection(props: Props) {
  const {
    arrayHelpers,
    defaultExpanded,
    disableGrayBg,
    entityType,
    loading,
    localMode,
    location,
    minimumServicesCount,
    readOnly,
    serviceFrequencies,
    totalServicesCount,
  } = props

  const { fullName, orderedServices } = useData({
    localMode,
    location,
  })

  const { handleCheckboxChange } = useHandlers({ arrayHelpers })

  const theme = useTheme()

  return (
    <SimpleAccordion
      //   square
      defaultExpanded={defaultExpanded}
      style={{
        backgroundColor: 'transparent',
        marginTop: theme.spacing(2),
      }}
    >
      <SimpleAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        style={{
          alignItems: 'start',
          backgroundColor: disableGrayBg ? undefined : 'rgb(250, 250, 250)',
        }}
      >
        <Title>Service Location:&nbsp;{fullName}</Title>
      </SimpleAccordionSummary>
      <SimpleAccordionDetails>
        {loading ? (
          <CircularProgress />
        ) : (
          <Stack direction="column">
            <ServiceList
              entityType={entityType}
              serviceFrequencies={serviceFrequencies}
              minimumServicesCount={minimumServicesCount}
              localMode={localMode}
              onCheckboxChange={handleCheckboxChange}
              readOnly={readOnly}
              services={orderedServices}
              totalServicesCount={totalServicesCount}
              disabled={false}
              loading={false}
            />
          </Stack>
        )}
      </SimpleAccordionDetails>
    </SimpleAccordion>
  )
}
